// extracted by mini-css-extract-plugin
module.exports = {"container":"StockScreenComponent_container__1xlw4","viewItems":"StockScreenComponent_viewItems__mkSLe"};